
import { Pointer } from 'lucide-react';
import {Navbar,Footer} from '../components';
import React,{useState} from "react";
import * as Icon from "react-bootstrap-icons";
import {Outlet, useNavigate } from "react-router-dom";
import modules from '../utils/modules.json';

function Home() {
  const navigate = useNavigate();

  if(localStorage.getItem('branchID')===null){
    window.location.replace('/');
  }

  const userAccess = JSON.parse(
  localStorage.getItem("userAccess") || "[]"
  );

      const [activeMenu, setActiveMenu] = useState("");
      const [openModule, setOpenModule] = useState("");

      const toggleModule = (moduleName) => {
        setOpenModule(openModule === moduleName ? "" : moduleName);
      };

      const [collapsed, setCollapsed] = useState(false);

  return (
    <>
    <div className="container-fluid" >

  <Navbar />

  <div className="d-flex" style={{marginTop:75}}>

    {/* SIDEBAR */}
    <div
      style={{
        minHeight: "100vh",
        background: "#1e293b",
        color: "white",
        width: collapsed ? "70px" : "260px",
        transition: "0.3s",
        
      }}
    >

      {/* Header */}
      <div className="p-3 d-flex justify-content-between align-items-center border-bottom" style={{ background: "#0f172a" }}>
        {!collapsed && <h5 className="m-0">Management Information System</h5>}

        <button
          onClick={() => setCollapsed(!collapsed)}
          style={{ background: "none", border: "none", color: "white" }}
        >
          {collapsed ? "☰" : "✕"}
        </button>
      </div>

      {/* MENU */}
      <div className="p-2">

        {modules.MIS.menue.map((module, index) =>{
        const MenuIcon = Icon[module.icon];
        return (
          <div key={index}>
            <div className="p-2 d-flex align-items-center gap-2" onClick={() => toggleModule(module.moduleName)}
              style={{ 
                cursor: "pointer",
                background:  openModule === module.moduleName ? "#334155" : "transparent", }}
            >
              {MenuIcon && <MenuIcon className="me-2" />}
              {!collapsed && module.moduleName}  
            </div>

            {!collapsed && openModule === module.moduleName && (
            <div className="ms-3 mt-2">
              {userAccess
                .filter(item => item.formGroup === module.moduleName)
                .map(menu =>(
                <div
                  key={menu.formName}
                  className="p-2 mb-1 rounded d-flex align-items-center gap-2 rounded"                  
                  onClick={() => 
                    menu.isEnabled==='Y'
                    ?  ( setActiveMenu(menu.formName), navigate(menu.path))
                    :  ""
                  }
                  style={{
                    cursor: menu.isEnabled==='Y' ? "pointer" : "not-allowed",
                    background: activeMenu === menu.formName ? "#2563eb" : "transparent",
                    opacity: menu.isEnabled==='Y' ? 1 : 0.5,
                  }}
                >  
                  {< Icon.CaretRightFill/>}       
                  <spam>{menu.formName.replaceAll("_", " ")}</spam>
                </div>
                ))
              }
            </div>
            )}
          </div>
        )}
        )}

      </div>

    </div>

    {/* MAIN BODY */}
    <div style={{ flex: 1, minHeight: "100vh" }}>
      <Outlet />
    </div>

  </div>

  <Footer />

</div>

    </>
  )
}

export default Home